import { nth } from 'lodash';
import { useGetList } from 'react-admin';
import { PROFILES } from '@/utils/CONST';

interface Params {
    profileName: string | undefined;
}

interface Output {
    profile: { [key: string]: any } | undefined;
    isLoading: boolean;
}

const useGetManagerProfile = ({ profileName }: Params): Output => {
    const { data, isLoading }: any = useGetList(
        PROFILES,
        {
            pagination: {
                page: 1,
                perPage: 1,
            },
            filter: {
                internalName: profileName,
            },
        },
        { enabled: !!profileName },
    );

    return {
        profile: nth(data),
        isLoading,
    };
};

export default useGetManagerProfile;
